import React, { useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';

const AddWallet = () => {
    const [amount, setAmount] = useState('');
    const [transactionType, setTransactionType] = useState('OUTGOING');
    const [description, setDescription] = useState('');
    const [loading, setLoading] = useState(false);  // Loading state to show a loading spinner
    const navigate = useNavigate();

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        // Basic form validation
        if (!amount || isNaN(amount) || amount <= 0) {
            alert('Please enter a valid amount.');
            return;
        }

        setLoading(true);

        const transactionData = {
            staff_id: 1,  // Static staff_id passed as 1
            amount,
            transaction_type: 'INCOMING',
            description
        };

        // Send POST request to create the new transaction
        fetch(`${BASE_URL}wallet/transaction`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(transactionData),
        })
            .then((response) => response.json())
            .then((data) => {
                setLoading(false);
                if (data.status === 1) {
                    alert(data.message); // Show success message
                    navigate('/WalletList'); // Navigate to the WalletList page after success
                } else {
                    alert('Error creating transaction. Please try again.');
                }
            })
            .catch((error) => {
                setLoading(false);
                console.error('Error adding transaction:', error);
                alert('There was an error adding the transaction. Please try again.');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Cash Received</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb">
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add Transaction Form start */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Add Cash Received</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="amount" className="form-label">Amount</label>
                                       <input
    type="text" // Use type="text" to avoid issues with scientific notation
    id="amount"
    className="form-control"
    value={amount}
    onChange={(e) => {
        const value = e.target.value;
        
        // Only allow digits (0-9) and empty value
        if (/^\d*$/.test(value)) {
            setAmount(value); // Update the state if valid
        }
    }}
    placeholder="Enter transaction amount"
    required
/>

                                    </div>

                                    

                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <input
                                            type="text"
                                            id="description"
                                            required
                                            className="form-control"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            placeholder="Enter description "
                                        />
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary" disabled={loading}>
                                            {loading ? 'Adding...' : 'Add Transaction'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Add Transaction Form end */}
        </div>
    );
};

export default AddWallet;
